import React, {useState} from 'react'
import {walletPaymentsName, features} from 'config'
import {actionsType} from 'config/constants'
import Checkbox from 'components/Forms/Inputs/ChecksGroup/checkbox'
import PubSub from 'services/PubSub'
import NewRelicService from 'services/NewRelic'
import TagManagerService from 'services/TagManager'
import WalletService from 'services/Wallet'
import style from './style.scss'//NOSONAR
import StorageService from 'services/StorageService'

const PaymentMethod = (props) => {
    const [checked, setChecked] = useState(false)
    const [dropdown, setDropdown] = useState(false)
    const [binError, setBinError] = useState(false)
    const [inputValue, setInputValue] = useState('')

    const oneClick = walletPaymentsName.oneClick
    const catOneClick = walletPaymentsName.catOneClick
    const debitOneClick = walletPaymentsName.debitOneClick
    const listCards = props.payload;

    const onChange = () => {
        setChecked(!checked)
    }

    const onInputChange = (e) => {
        setInputValue(e.target.value)
    }

    const addCard = (type, bin = null, e) => {
        if (e) e.preventDefault()
        if (!checked) return false
        if (type === catOneClick && !bin) return false

        WalletService.addWalletCard(type, bin)
            .then((response) => {
                if (response.results) {
                    NewRelicService.sendPageAction({
                        action: 'addCard',
                        payload: {
                            status: 'redirect',
                        },
                    })
                    if(type === 'DebitoOneClick'){
                        if(features.prepaid) {
                            type= 'Tarjeta de débito o prepago'
                        } else {
                            type = 'Tarjeta de débito'
                        }
                        
                    }

                    if(type === 'OneClick') {
                        type = 'Tarjeta de credito'
                    }

                    if(type === 'CATOneClick') {
                        type = 'Tarjeta cencosud'
                    }

                    TagManagerService.interaction('Step 2: Click botón guardar tarjeta', type, 'Agregar nuevo medio de pago')
                    PubSub.dispatch(actionsType.DRAWER.PAYMENT_METHOD_CLOSE)
                    setBinError(false)
                    setTimeout(() => {
                        StorageService.setItem('card-payment', JSON.stringify({type, listCards}))
                        window.location = response.results

                    }, 300)
                } else if (response.status === 400) {
                    setBinError(true)
                }
            })
    }

    const openDropdown = () => {
        if (!checked) return false
        setDropdown(!dropdown)
    }

    const goBack = () => {
        PubSub.dispatch(actionsType.DRAWER.PAYMENT_METHOD_CLOSE)
    }

    return (
        <div className="drawer-container drawer-payment-method-container">
            <h1 className="drawer-title drawer-payment-method-title">Agregar nuevo medio de pago</h1>
            <div className="drawer-scroll">
                <p className="drawer-payment-method-paragraph">
                    Al registrar tu tarjeta, <b>aceptas que Webpay guarde tu información para realizar cobros.</b>
                    <br />
                    El registro se validará efectuando un cargo provisorio de 50 pesos que luego se devolverán a tu tarjeta. Solo debes
                    utilizar medios de pago emitidos en Chile.
                </p>
                <div className="drawer-payment-method-checkbox" onClick={onChange}>
                    <Checkbox type={'checkbox'} name={'Acceptance of drawer payment method'} checked={checked} onChange={onChange} />
                    <label className="drawer-payment-method-checkbox-label" onClick={onChange}>
                        Acepto que se guarden los datos de la tarjeta
                    </label>
                </div>
                <div className={`drawer-payment-method-card-box ${dropdown ? 'opened' : ''}`}>
                    <h3 className="drawer-payment-method-card-text">Tarjeta Cencosud Scotiabank</h3>
                    <button
                        className={`new-link new-link-small drawer-payment-method-card-button ${!checked ? 'disable' : ''}`}
                        onClick={openDropdown}>
                        {!dropdown ? 'Guardar tarjeta' : ''}
                    </button>
                    <div className={`drawer-payment-method-dropdown ${dropdown ? 'opened' : ''}`}>
                        <p className="drawer-payment-method-dropdown-message">Ingresa los primeros 6 números de tu tarjeta</p>
                        <form className={`drawer-payment-method-dropdown-form input-wrapper ${binError ? ' input-error ' : ''}`} onSubmit={(e) => addCard(catOneClick, inputValue, e)}>
                            <input
                                className={`drawer-payment-method-dropdown-input input-default`}
                                placeholder="Ejemplo: 123456"
                                maxLength={6}
                                onBlur={() => setBinError(false)}
                                onChange={onInputChange}
                                value={inputValue}
                            />
                            {binError && <i className="jumbo-icon-new-close"></i>}
                            <button
                                className={`drawer-payment-method-dropdown-button ${!checked ? 'disable' : ''}`}
                                type="submit"
                                disabled={!checked}>
                                Agregar
                            </button>
                        </form>
                    </div>
                </div>
                <div className="drawer-payment-method-card-box">
                    <h3 className="drawer-payment-method-card-text">Tarjeta de crédito</h3>
                    <button
                        className={`new-link new-link-small drawer-payment-method-card-button ${!checked ? 'disable' : ''}`}
                        onClick={() => addCard(oneClick)}>
                        Guardar tarjeta
                    </button>
                </div>
                <div className="drawer-payment-method-card-box">
                    <h3 className="drawer-payment-method-card-text">{`Tarjeta de débito ${features.prepaid ? ' o prepago': ''}`}</h3>
                    <button
                        className={`new-link new-link-small drawer-payment-method-card-button ${!checked ? 'disable' : ''}`}
                        onClick={() => addCard(debitOneClick)}>
                        Guardar tarjeta
                    </button>
                </div>
            </div>
            <div className="drawer-actions drawer-payment-method-actions">
                <button className="primary-btn" onClick={goBack}>Volver</button>
            </div>
        </div>
    )
}

export default PaymentMethod
